package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DisableUserPayload(
    @SerialName("userID")
    val userId: String,
    val organization: String,
    val disable: Boolean,
)

@Serializable
data class CommonSingleDataResponse(
    val data: String,
)